import React from 'react';
import { select } from 'redux-saga/effects';
import { Typography } from '@material-ui/core';
import _ from 'lodash';

// eslint-disable-next-line import/no-cycle
import store from '../store';
import * as actions from '../state';

import { generateId } from '../utils';
import { changeBoard } from '../events';

import createBoardService from './services/board/createBoard';
import updateBoardService from './services/board/updateBoard';
import fetchBoardListService from './services/board/fetchBoardList';
import createChartService from './services/chart/createChart';

export default function* copyBoard(event) {
  // eslint-disable-next-line no-undef
  const boardCopy = _.cloneDeep(event.payload.board);
  // eslint-disable-next-line no-undef
  const chartsCopy = _.cloneDeep(event.payload.charts);

  const { intl } = event.payload;
  const { messages } = event.payload;

  const copyMsg = intl.formatMessage({ ...messages.COPY });
  const copiedMsg = intl.formatMessage({ ...messages.BOARD_COPIED });
  const linkMsg = intl.formatMessage({ ...messages.BOARD_LINK_TEXT });

  const user = yield select((state) => actions.readStateUser(state));

  boardCopy.id = null; // null the id so a new record is created
  boardCopy.name = `${boardCopy.name} (${copyMsg})`; // use the same name but add '(COPY)'
  boardCopy.domain = user.domain; // use the user's domain (which should be the same until we support cross domain behaviors)
  boardCopy.owner_type = 1; // update owner
  boardCopy.owner_id = user.userId; // update owner
  boardCopy.public_id = generateId(8); // generate a new public id
  boardCopy.share_type = 'select'; // clear share settings
  boardCopy.share_details = []; // clear share settings

  createBoardService({
    user: user.userId,
    domain: user.domain,
    board: boardCopy,
  }).then((newBoardId) => {
    boardCopy.id = newBoardId;

    fetchBoardListService({ domain: user.domain }).then((boardList) => {
      store.dispatch(actions.setBoardList(boardList));
    });

    /* save each chart */
    const allPromises = chartsCopy.map((chart) => {
      // eslint-disable-next-line no-undef
      const newChart = _.cloneDeep(chart);
      const oldId = newChart.id; // remember the old id so we can swap it out in the layout with the new id
      // eslint-disable-next-line no-param-reassign
      newChart.id = null; // null the id so a new record is created
      // eslint-disable-next-line no-param-reassign
      newChart.dashboard_id = newBoardId;
      // generate a placeholder ID, will be replaced after an ID is allocated by the API
      newChart.properties.placeholder_id = `new_${generateId(4)}`;

      return createChartService({
        user: user.userId,
        domain: user.domain,
        chart: newChart,
      }).then((newChartId) => {
        boardCopy?.layouts?.lg?.forEach((gridItem) => { // search the layout for the old id, swap it
          if (gridItem.i.toString() === oldId.toString()) { // needed to cast this as a string, likely do to same reason MB wrote note 2 lines down.
            // eslint-disable-next-line no-param-reassign
            gridItem.i = newChartId.toString(); // I don't know why gridItem. i needs to be a string, but it do
          }
        });
      });
    });

    Promise.all(allPromises).then(() => { // all network requests have returned
      updateBoardService({ // save board again now that the layout is updated with new chart ids
        user: user.userId,
        domain: user.domain,
        board: boardCopy,
      });

      store.dispatch(actions.isLoading(false));
      store.dispatch(actions.showToaster({
        show: true,
        message: copiedMsg,
        type: 'success',
        action: (
          <Typography
            gutterBottom
            onClick={() => store.dispatch(changeBoard(boardCopy.id))}
            style={{ color: '#fff' }}
          >
            {linkMsg}
          </Typography>
        ),
      }));
    });
  });
}
